import apiClient from '../api.js';
import { conToken } from '../autorizacion.js';

// Sede activa de la sesión (selector del encabezado). Backend:
// `UNICEN/modules/sesion`.
//
//   GET  /sesion/contexto
//        -> { id_sede, id_sede_propia, puede_cambiar_sede, sedes: [{ id_sede, nombre }] }
//        `sedes` viene vacío para quien no puede cambiar de sede.
//
//   POST /sesion/sede  body { id_sede }
//        -> { token, id_sede, sede }  token nuevo con la sede elegida y el mismo vencimiento
//        403 si el rol no puede cambiar de sede, 404 si la sede no existe.
const resource = '/sesion';

const useSesionApi = {
  obtenerContexto() {
    return apiClient.get(`${resource}/contexto`, conToken());
  },

  cambiarSede(idSede) {
    return apiClient.post(`${resource}/sede`, { id_sede: idSede }, conToken());
  },
};

export default useSesionApi;
